import { render, staticRenderFns } from "./CallGateWayDeviceList.vue?vue&type=template&id=068ffbb0&scoped=true"
import script from "./CallGateWayDeviceList.vue?vue&type=script&lang=js"
export * from "./CallGateWayDeviceList.vue?vue&type=script&lang=js"
import style0 from "./CallGateWayDeviceList.vue?vue&type=style&index=0&id=068ffbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ffbb0",
  null
  
)

export default component.exports